import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO12 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK001-2.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO12
